import getEnvironment from 'utils/getEnvironment'
import { getCoverageType } from './getCoverageType'
import getURLProfile from 'utils/pivot/member/getURLProfile'
import { getISODate, stringToDate } from '@hc-frontend/utils'
import isSalesCenterSubDomain from 'utils/pivot/isSalesCenterSubDomain'
import { getCarrierName } from '../utils'

function makePayload({ quoteKey, hcStorage, opportunityId, leadId, plan }) {
  const isTest = String(hcStorage.agent_id).includes('TEST') ? 'Yes' : 'No'

  const fee =
    plan.fee && typeof plan.fee === 'string' ? +plan.fee.replace('$', '') : plan.fee

  const data = {
    idLead: leadId,
    header: {
      isATest__c: isTest,
      planId: plan.planId,
      planType: plan.planType,
      planName: plan.planName,
      product: plan.product,
      coverageType: getCoverageType(plan.product),
      carrier: getCarrierName(plan.carrier),
      placement: hcStorage.placement,
      period: hcStorage.period || '',
      monthlyCost: plan.monthlyCost,
      oneTimeFee: fee,
      policies: hcStorage.policies || '',
      eligibilityStatus: !document.querySelectorAll('input[value="YES"]:checked').length,
      leadType: 'U65',
      PolicyIssued__c: 'Yes'
    }
  }

  if (plan.moop) {
    data.header['moop'] = plan.moop
  }

  if (plan.deductible) {
    data.header['deductible'] = plan.deductible
  }

  if (hcStorage.sdate) {
    data.header['sdate'] = getISODate(stringToDate(hcStorage.sdate))
  }

  if (hcStorage.endDate) {
    data.header['endDate'] = getISODate(stringToDate(hcStorage.endDate))
  }

  if (opportunityId) {
    data['idOpportunity'] = opportunityId
  }

  data.header['emailQuoteLink'] =
    window.location.origin +
    window.location.pathname +
    '?' +
    getURLProfile({ placement: hcStorage.placement })

  if (quoteKey) {
    const env = getEnvironment()
    const environment = env === 'prd' ? '' : `.${env}`

    if (isSalesCenterSubDomain()) {
      data.header[
        'backTo'
      ] = `https://sales${environment}.pivothealth.com/product/short-term-health-insurance/quotes/?quoteKey=${quoteKey}`
    } else {
      const profile = getURLProfile({
        salesCenterAgent: true,
        placement: hcStorage.placement,
        agentId: hcStorage.agent_id
      })

      data.header['backTo'] = `https://${environment.substring(
        1
      )}.pivothealth.com/product/short-term-health-insurance/quotes?${profile}&quoteKey=${quoteKey}`
    }
  }

  return data
}

export default makePayload
